import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import ChipStatus from "@/components/ChipStatus";
import HasPermission from "@/components/commons/HasPermission";
import { useTranslation } from "@/langs/useTranslation";
import { getScheduledDeviceHistoryListApi } from "@/apis/apiCollection";
import { formatDate } from "./datetimeHandlers";
import ScheduleTaskType from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskType";
import { ExcuteChipStatus } from "@/components/FormFields/ExcuteStatus";

export const ScheduleHistoryListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      getSearchParams,
      footer,
      children,
      onCheckAll,
      onLoaded,
      onDelete
    },
    ref
  ) => {
    const { t } = useTranslation();
    const history = useHistory();

    const toDetail = e => {
      e.preventDefault();
      const url = new URL(e.target.href);
      history.push(url.pathname);
    };

    const columns = [
      {
        data: "id",
        type: "checkbox"
      },
      {
        data: "deviceSerialNumber",
        title: t({ defaultMessage: "设备SN" }),
        createdCell: (td, data, rowData) => {
          ReactRender(
            <HasPermission permission="Device Monitoring Detail">
              {yes =>
                yes ? (
                  <a
                    href={`/device-list/device-detail/${rowData.deviceId}/${
                      rowData.os_type || "android"
                    }`}
                    onClick={toDetail}
                  >
                    {data}
                  </a>
                ) : (
                  data
                )
              }
            </HasPermission>,
            td
          );
        }
      },
      {
        name: "deviceName",
        data: "deviceName",
        orderable: false,
        title: t({ defaultMessage: "设备名称" })
      },
      {
        name: "deviceDetail",
        data: "deviceDetail",
        orderable: false,
        title: t({ defaultMessage: "描述" })
      },
      {
        name: "groups",
        orderable: false,
        data: row => {
          return row.groups.map(item => item.name).join(", ");
        },
        title: `${t({ defaultMessage: "门店" })}`
      },
      {
        name: "tags",
        orderable: false,
        data: row => {
          return row.tags.map(item => item.name).join(", ");
        },
        title: t({ defaultMessage: "标签" })
      },
      {
        name: "companies",
        orderable: false,
        title: `${t({ defaultMessage: "拥有者" })}`,
        data: row => {
          return row.companies.map(item => item.name).join(", ");
        }
      },
      {
        data: "deviceStatus",
        orderable: false,
        title: t({ defaultMessage: "设备状态" }),
        createdCell: (td, data) => {
          ReactRender(
            <ChipStatus
              type={data === 0 ? "success" : "default"}
              label={
                data === 0
                  ? t({ defaultMessage: "在线" })
                  : t({ defaultMessage: "离线" })
              }
            />,
            td
          );
        }
      },
      {
        data: "scheduleTemplateName",
        title: t({ defaultMessage: "排程模板" })
      },
      {
        data: "taskType",
        title: t({ defaultMessage: "排程任务" }),
        createdCell: (td, data, row) => {
          ReactRender(<ScheduleTaskType data={row} />, td);
        }
      },
      {
        data: "executedStatus",
        orderable: false,
        title: t({ defaultMessage: "执行状态" }),
        createdCell: (td, data) => {
          ReactRender(<ExcuteChipStatus status={data} />, td);
        }
      },
      {
        data: "executedDate",
        title: t({ defaultMessage: "实际执行时间" }),
        render: (data, type, row) => {
          // if (row.executedStatus === "ignored" || !row.executedStatus) {
          //   return "";
          // }
          return formatDate(data, "YYYY-MM-DD HH:mm", "-", true);
        }
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        className: "center nowrap",
        searchable: false,
        orderable: false,
        createdCell: (td, data, row) => {
          ReactRender(
            <HasPermission permission="schedule_task_history_alarm_delete">
              <Button
                size="small"
                color="secondary"
                onClick={() => onDelete(row)}
              >
                {t({ defaultMessage: "删除" })}
              </Button>
            </HasPermission>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      let orderType;
      let orderWay;
      const order = data.order[0];
      if (order) {
        // orderType = data.columns[order.column]?.name;
        orderType = order.column;
        orderWay = order.dir === "asc" ? 1 : 2;
      }
      return getScheduledDeviceHistoryListApi({
        // ...data,
        orderType,
        orderWay,
        ...getSearchParams(),
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.scheduledDeviceHistories,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        ordering
        options={{ order: [[8, "desc"]] }}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        scrollable
        showCheckAll={false}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
